import { render } from "./Footer.htm?vue&type=template&id=1b22e25c&scoped=true"
import script from "./Footer.js?vue&type=script&lang=js"
export * from "./Footer.js?vue&type=script&lang=js"

import "./Footer.scss?vue&type=style&index=0&id=1b22e25c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b22e25c"]])

export default __exports__